// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopoverMenu__container-da3bce {
  min-width: 160px;
  max-height: 60vh;
  box-sizing: border-box;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/PopoverMenu/PopoverMenu.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  min-width: 160px;\n  max-height: 60vh;\n  box-sizing: border-box;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PopoverMenu__container-da3bce`
};
module.exports = ___CSS_LOADER_EXPORT___;
